import { Component, input } from '@angular/core';

import { AuxIconName } from '../icon/icon';
import { IconComponent } from '../icon/icon.component';

@Component({
  host: {
    class: 'block',
  },
  imports: [IconComponent],
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'info-section',
  template: `
    <section
      class="flex items-center space-x-4 rounded-[8px] border border-aux-gray-light-4 border-opacity-10 bg-white p-4"
    >
      @if (icon()) {
        <aux-icon [name]="icon()!" [size]="20" [class]="iconClass()" />
      }
      <p class="text-lg font-semibold text-aux-black">{{ message() }}</p>
    </section>
  `,
})
export class InfoSectionComponent {
  icon = input<AuxIconName>();
  iconClass = input<string>('');
  message = input<string>('');
}
